// Helpers for starting auth while remembering where the user was, so an
// existing user is returned to the same spot after logging in.
//
// IMPORTANT: the return path must live in the URL query (?redirect=...), NOT in
// React Router `state`. After an existing-user login, LoginPage does a full
// window.location.reload(), which discards router state — only the URL survives.
// The /login redirect shim reads ?redirect= and navigates back there once the
// Ask Witty auth card has established userData.

import { requestAskWittyAuth } from "./askWittyAuthIntent";

export function buildLoginRedirectUrl(currentPathWithQuery) {
  const raw = String(currentPathWithQuery || "").trim();
  // Only allow internal, absolute-from-root paths (avoid open-redirects).
  const safe = raw.startsWith("/") && !raw.startsWith("//") ? raw : "/";
  return `/login?redirect=${encodeURIComponent(safe)}`;
}

// Current SPA location as a path + query + hash string.
export function currentAppPath() {
  if (typeof window === "undefined" || !window.location) return "/";
  const { pathname, search, hash } = window.location;
  return `${pathname || "/"}${search || ""}${hash || ""}`;
}

// Start login. Ask Witty handles it in place whenever its sidecar is mounted,
// so the user keeps the page they were on; /login stays the fallback for the
// routes the sidecar does not cover.
// Pass a react-router `navigate` function.
export function goToLogin(navigate, options = {}) {
  const returnTo = options.returnTo || currentAppPath();
  if (requestAskWittyAuth({ returnTo, reason: options.reason || "login" })) return;
  const url = buildLoginRedirectUrl(returnTo);
  if (typeof navigate === "function") {
    navigate(url);
  } else if (typeof window !== "undefined") {
    window.location.assign(url);
  }
}
